/**
 * Minimal ABI for RevenueSplitter (versioned split configs).
 * See nft-codebase/contracts/RevenueSplitter.sol
 *
 * Share values are uint256 summing to 100 (integer percentages, misnamed *Bps in Solidity).
 */
const RevenueSplitterABI = [
  {
    inputs: [],
    name: 'DAO_OPERATOR_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'hasRole',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'latestVersion',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'activeVersion',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getAllSplitConfigs',
    outputs: [
      { internalType: 'uint256[]', name: 'versions', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'lpShareBps', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'daoTreasuryBps', type: 'uint256[]' },
      { internalType: 'uint256[]', name: 'platformBps', type: 'uint256[]' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'lpShareBps', type: 'uint256' },
      { internalType: 'uint256', name: 'daoTreasuryBps', type: 'uint256' },
      { internalType: 'uint256', name: 'platformBps', type: 'uint256' },
    ],
    name: 'setSplitConfig',
    outputs: [{ internalType: 'uint256', name: 'version', type: 'uint256' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'version', type: 'uint256' }],
    name: 'setActiveVersion',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

export default RevenueSplitterABI;
export { RevenueSplitterABI };
